import type { SxProps, Theme } from '@mui/material';

export const getWrapperSx = (sx?: SxProps<Theme>) => ({
  flexDirection: 'row', flexWrap: 'wrap', gap: 6,
  alignItems: 'center', justifyContent: 'start',
  ...sx,
}) as const;

export const buttonSx = {
  p: 10,
  flex: '0 0 calc((100% - 2 * 24px) / 3)', // 2 gaps * 24px
  height: '144',
};

export const getKeyButtonSx = (theme: Theme) => ({
  ...buttonSx,
  color: theme.palette.dark,
});

export const getClearButtonSx = (theme: Theme) => ({
  ...buttonSx,
  background: 'transparent',
  color: theme.palette.white_100,
  '&.Mui-disabled': {
    color: theme.palette.white_100,
  },
});